import imageSizes from '../../constants/imageSizes'
import type { Definition } from '../../types'

export const SdrLabels: Definition = {
  contentType: 'SdrLabels',
  fields: [
    {
      id: 'bookingText',
      name: 'Booking text',
      type: 'Symbol'
    }
  ]
}

export const PageSdrSolutionOverview: Definition = {
  contentType: 'PageSdrSolutionOverview',
  fields: [
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol'
    },
    {
      id: 'shortDescription',
      name: 'Short description',
      type: 'Symbol'
    },
    {
      id: 'heroImage',
      name: 'HeroImage',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns5_34, lazy: true }
    },
    {
      id: 'logoBar',
      name: 'Logo Bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'highLevelContentBlock',
      name: 'High level content block',
      type: ['ModuleVideo', 'ModuleInternalVideo', 'BlockGroup', 'BlockUspList'],
      imageOptions: {
        lazy: true
      }
    },
    {
      id: 'featureContentBlock',
      name: 'Feature Content Block',
      type: 'Array',
      subType: [
        'BlockContent',
        'ModuleVideo',
        'ModuleInternalVideo',
        'BlockCallToActionWithMedia',
        'BlockUspList',
        'BlockMediaCardGroup',
        'BlockLandingMediaAndText',
        'BlockLogoBar'
      ],
      validations: [{ size: { min: 1, max: 4 } }]
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'pageContentComponentName',
      name: 'Page Content Component Name',
      type: 'Symbol'
    }
  ]
}

export const PageSdrBusinessCase: Definition = {
  contentType: 'PageSdrBusinessCase',
  fields: [
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol'
    },
    {
      id: 'video',
      name: 'Video',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { sizes: imageSizes.columns12_5269, lazy: true }
    },
    {
      id: 'tabContent',
      name: 'Content with Tabs',
      type: 'BlockGroup',
      subType: 'BlockTabContentLazy',
      lazy: true,
      imageOptions: { sizes: imageSizes.columns6_34, lazy: true }
    },
    {
      id: 'benefits',
      name: 'Benefits',
      type: 'BlockUspList'
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent'
    },
    {
      id: 'pageContentComponentName',
      name: 'Page Content Component Name',
      type: 'Symbol'
    }
  ]
}

export const PageSdrOverview: Definition = {
  contentType: 'PageSdrOverview',
  fields: []
}

export default {
  SdrLabels,
  PageSdrSolutionOverview,
  PageSdrBusinessCase,
  PageSdrOverview
}
